import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConfirmDialogState {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  danger: boolean;
  resolve: ((v: boolean) => void) | null;
}

const CLOSED: ConfirmDialogState = {
  open: false, title: '', message: '', confirmLabel: 'Delete', danger: true, resolve: null
};

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private _state = new BehaviorSubject<ConfirmDialogState>(CLOSED);
  state$ = this._state.asObservable();

  confirm(message: string, options?: { title?: string; confirmLabel?: string; danger?: boolean }): Promise<boolean> {
    return new Promise(resolve => {
      this._state.next({
        open: true,
        title: options?.title ?? 'Confirm',
        message,
        confirmLabel: options?.confirmLabel ?? 'Delete',
        danger: options?.danger ?? true,
        resolve
      });
    });
  }

  respond(value: boolean) {
    const current = this._state.value;
    this._state.next(CLOSED);
    current.resolve?.(value);
  }
}
